import { useCallback } from "react";
import { useAppDispatch } from "utils/redux/hooks";
import { setChatbotMessages, setThreadId } from "app/containers/Chatbot/slice";
import { ChatbotConversation } from "app/containers/Chatbot/types";
import { useNavigate } from "./navigation";

// Loads a saved conversation into the chatbot and routes to the matching
// screen (check-in conversations open in the check-in view).
export const useOpenConversation = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(
    (conversation: ChatbotConversation) => {
      dispatch(setThreadId(conversation.threadId));
      dispatch(setChatbotMessages(conversation.messages));
      const path = conversation.weeklyCheckInLink
        ? "/user/checkIn"
        : "/user/chatWithBo";
      navigate(path, { id: path });
    },
    [dispatch, navigate]
  );
};
